<template>
  <div class="container">
    <div class="top_title"><router-link class="icon_back" :to="{name:'H200010'}" tag="span"></router-link>
      回访详细</div>
    <div class="scroll_area" style="overflow-y: auto">
      <div class="student_info_title" style="margin-top: 2.6rem">
        <span class="icon_student_info"></span>
        <span>学员信息</span>
      </div>
      <div class="student_items">
        <div class="weui-cells item">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>姓名</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="info.I_STUDENT_NAME"/>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>校区</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="info.I_SCHOOL_NAME"/>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>班级</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="info.I_CLASS_NAME"/>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>老师</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="info.I_TEACHER" />
            </div>
          </div>
        </div>
      </div>
      <div class="teacher_info_title">
        <span class="icon_parent_info"></span>
        <span>家长信息</span>
      </div>
      <div class="weui-cells item" style="border: 0!important;margin-bottom: 0.66rem">
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>联系电话</p>
          </div>
          <div class="weui-cell__ft">
            <a class="call" :href='"tel://" + info.I_TEL'>
              <input type="text" class="input_text tel" disabled :value="info.I_TEL"/>
              <span></span>
            </a>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>回访日期</p>
          </div>
          <div class="weui-cell__ft">
            <input type="text" class="input_text" disabled :value="info.I_DATE"/>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>回访对象</p>
          </div>
          <div class="weui-cell__ft family_member">
            <span :class="{active: info.I_REVISIT_USER_TYPE == '爸爸'}" @click="info.I_REVISIT_USER_TYPE = '爸爸'">爸爸</span>
            <span :class="{active: info.I_REVISIT_USER_TYPE == '妈妈'}" @click="info.I_REVISIT_USER_TYPE = '妈妈'">妈妈</span>
            <span :class="{active: info.I_REVISIT_USER_TYPE == '其他'}" @click="info.I_REVISIT_USER_TYPE = '其他'">其他</span>
          </div>
        </div>
    </div>
      <div class="weui-cells item visitRecords">
        <p class="title"><span></span>回访记录</p>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>1.电话复习</p>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>拼音意识</p>
          </div>
          <div class="weui-cell__ft radios yyys">
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_1=='A'}"></span><span>A</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_1=='B'}"></span><span>B</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_1=='C'}"></span><span>C</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_1=='-'}"></span><span>-</span></label>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>拼读</p>
          </div>
          <div class="weui-cell__ft radios pd">
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_2=='A'}"></span><span>A</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_2=='B'}"></span><span>B</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_2=='C'}"></span><span>C</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_2=='-'}"></span><span>-</span></label>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>单词掌握</p>
          </div>
          <div class="weui-cell__ft radios dczw">
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_3=='A'}"></span><span>A</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_3=='B'}"></span><span>B</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_3=='C'}"></span><span>C</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_3=='-'}"></span><span>-</span></label>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>听力理解</p>
          </div>
          <div class="weui-cell__ft radios tllj">
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_4=='A'}"></span><span>A</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_4=='B'}"></span><span>B</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_4=='C'}"></span><span>C</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_4=='-'}"></span><span>-</span></label>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>口语表达</p>
          </div>
          <div class="weui-cell__ft radios kybd">
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_5=='A'}"></span><span>A</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_5=='B'}"></span><span>B</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_5=='C'}"></span><span>C</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_5=='-'}"></span><span>-</span></label>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>阅读流畅</p>
          </div>
          <div class="weui-cell__ft radios ydlc">
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_6=='A'}"></span><span>A</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_6=='B'}"></span><span>B</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_6=='C'}"></span><span>C</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_6=='-'}"></span><span>-</span></label>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>阅读理解</p>
          </div>
          <div class="weui-cell__ft radios ydlj">
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_7=='A'}"></span><span>A</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_7=='B'}"></span><span>B</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_7=='C'}"></span><span>C</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_7=='-'}"></span><span>-</span></label>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>语法理解</p>
          </div>
          <div class="weui-cell__ft radios yflj">
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_8=='A'}"></span><span>A</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_8=='B'}"></span><span>B</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_8=='C'}"></span><span>C</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_8=='-'}"></span><span>-</span></label>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>2.家长沟通</p>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>课堂表现</p>
          </div>
          <div class="weui-cell__ft radios ktbx">
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_A1=='A'}"></span><span>A</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_A1=='B'}"></span><span>B</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_A1=='C'}"></span><span>C</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_A1=='-'}"></span><span>-</span></label>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>课后复习</p>
          </div>
          <div class="weui-cell__ft radios khfx">
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_A2=='A'}"></span><span>A</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_A2=='B'}"></span><span>B</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_A2=='C'}"></span><span>C</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_A2=='-'}"></span><span>-</span></label>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>行为习惯</p>
          </div>
          <div class="weui-cell__ft radios xwxg">
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_A3=='A'}"></span><span>A</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_A3=='B'}"></span><span>B</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_A3=='C'}"></span><span>C</span></label>
            <label @click="clickRadio($event)"><span class="icon_yq" :class="{active: info.I_VALUE_A3=='-'}"></span><span>-</span></label>
          </div>
        </div>

        <div class="reasons">
          <p class="reasons-title">不续费调查原因</p>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>效果不好</p>
            </div>
            <div class="weui-cell__ft checkbox">
              <span @click="clickCheck($event,'I_VALUE_B1')" :class="{active: info.I_VALUE_B1=='Y'}"></span>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>接送问题</p>
            </div>
            <div class="weui-cell__ft checkbox">
              <span @click="clickCheck($event,'I_VALUE_B2')" :class="{active: info.I_VALUE_B2=='Y'}"></span>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>搬家</p>
            </div>
            <div class="weui-cell__ft checkbox">
              <span @click="clickCheck($event,'I_VALUE_B3')" :class="{active: info.I_VALUE_B3=='Y'}"></span>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>价格不合适</p>
            </div>
            <div class="weui-cell__ft checkbox">
              <span @click="clickCheck($event,'I_VALUE_B4')" :class="{active: info.I_VALUE_B4=='Y'}"></span>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>课程体系不合适对学校课程没有帮助</p>
            </div>
            <div class="weui-cell__ft checkbox">
              <span @click="clickCheck($event,'I_VALUE_B5')" :class="{active: info.I_VALUE_B5=='Y'}"></span>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>距离太远</p>
            </div>
            <div class="weui-cell__ft checkbox">
              <span @click="clickCheck($event,'I_VALUE_B6')" :class="{active: info.I_VALUE_B6=='Y'}"></span>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>坚持不了</p>
            </div>
            <div class="weui-cell__ft checkbox">
              <span @click="clickCheck($event,'I_VALUE_B7')" :class="{active: info.I_VALUE_B7=='Y'}"></span>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>口语不行</p>
            </div>
            <div class="weui-cell__ft checkbox">
              <span @click="clickCheck($event,'I_VALUE_B8')" :class="{active: info.I_VALUE_B8=='Y'}"></span>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>其他</p>
            </div>
            <div class="weui-cell__ft checkbox">
              <span @click="clickCheck($event,'I_VALUE_B9')" :class="{active: info.I_VALUE_B9=='Y'}"></span>
            </div>
          </div>
        </div>

        <!--<textarea class="parent_communication" placeholder="请输入沟通内容" v-model="info.I_REMARK"></textarea>-->
        <el-input
          style="border: 0;outline: none;"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 10}"
          placeholder="请输入沟通内容"
          v-model="info.I_REMARK">
        </el-input>
      </div>

      <button class="bottom_btn" @click="save">保存</button>
      <!-- <p class="mark">新保存的回访记录30分钟内可修改</p> -->
    </div>
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import weui from 'weui.js'
  export default {
    name: '',
    data () {
      return {
        info: {},
      }
    },
    created() {
      let info = this.$route.params.info

      if(info) {
        window.localStorage.setItem("H200020",info)
        info = JSON.parse(info)
      } else {
        info = JSON.parse(window.localStorage.getItem("H200020"))
      }

      DataRequestFactory.I200020(info).then((response) => {
        this.info = response
      })
    },
    methods: {
      clickCheck(e, value) {
        if($(e.currentTarget).hasClass("active")) {
          $(e.currentTarget).removeClass("active")
          this.info[value] = 'N'
        } else {
          $(e.currentTarget).addClass("active")
          this.info[value] = 'Y'
        }
      },
      clickRadio(e) {
        if( !$(e.currentTarget).find('.icon_yq').hasClass("active")) {
          $(e.currentTarget).parent().find('.icon_yq.active').removeClass("active")
          $(e.currentTarget).find('.icon_yq').addClass("active")
        } else {
          $(e.currentTarget).find('.icon_yq').removeClass("active")
        }
      },
      save () {
        if($('.yyys .icon_yq.active').length != 0) {
          this.info.I_VALUE_1 = $('.yyys .icon_yq.active').parent().find("span:last-child")[0].textContent
        }
        if($('.pd .icon_yq.active').length != 0) {
          this.info.I_VALUE_2 = $('.pd .icon_yq.active').parent().find("span:last-child")[0].textContent
        }
        if($('.dczw .icon_yq.active').length != 0) {
          this.info.I_VALUE_3 = $('.dczw .icon_yq.active').parent().find("span:last-child")[0].textContent
        }
        if($('.tllj .icon_yq.active').length != 0) {
          this.info.I_VALUE_4 =$('.tllj .icon_yq.active').parent().find("span:last-child")[0].textContent
        }
        if($('.kybd .icon_yq.active').length != 0) {
          this.info.I_VALUE_5 = $('.kybd .icon_yq.active').parent().find("span:last-child")[0].textContent
        }
        if($('.ydlc .icon_yq.active').length != 0) {
          this.info.I_VALUE_6 = $('.ydlc .icon_yq.active').parent().find("span:last-child")[0].textContent
        }
        if($('.ydlj .icon_yq.active').length != 0) {
          this.info.I_VALUE_7 = $('.ydlj .icon_yq.active').parent().find("span:last-child")[0].textContent
        }
        if($('.yflj .icon_yq.active').length != 0) {
          this.info.I_VALUE_8 = $('.yflj .icon_yq.active').parent().find("span:last-child")[0].textContent
        }

        if($('.ktbx .icon_yq.active').length != 0) {
          this.info.I_VALUE_A1 = $('.ktbx .icon_yq.active').parent().find("span:last-child")[0].textContent
        }
        if($('.khfx .icon_yq.active').length != 0) {
          this.info.I_VALUE_A2 = $('.khfx .icon_yq.active').parent().find("span:last-child")[0].textContent
        }
        if($('.xwxg .icon_yq.active').length != 0) {
          this.info.I_VALUE_A3 = $('.xwxg .icon_yq.active').parent().find("span:last-child")[0].textContent
        }

        DataRequestFactory.I200021(this.info).then((response) => {
          if(response.resultCode == 0) {
            weui.topTips("保存成功");
            let H200020Info = {
              I_SCHOOL_NO: this.info.I_SCHOOL_NO,
              I_CLASS_NO: this.info.I_CLASS_NO,
              I_STUDENT_NO: this.info.I_STUDENT_NO
            }
            this.$router.push({name:'H200010', params: {info: JSON.stringify(H200020Info)}})
          }
        })
      }
    },
    mounted() {
      var win_h = $(window).height();  //关键代码
      $("body").height(win_h);  //关键代码
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H200020.css';
  @import '../assets/css/common.css';
</style>
<style>
  .el-textarea__inner {
    border: 0;
    outline: none;
    padding: 0.8rem;
    width: 100%;
    height: 8rem;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/pages/H200020.vue